import { Card } from '@/components/ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useFacebookMedia } from '@/hooks/useFacebookMedia';
import { motion } from 'framer-motion';
import { ReactElement } from 'react';

export const ContentMediaAnalysisCard = (): ReactElement | null => {
  const { data: media } = useFacebookMedia();
  const latestPost = media?.[1];

  if (!latestPost) {
    return null;
  }

  return (
    <Card className="p-5 h-max w-full">
      <div className="flex flex-col gap-2">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h2 className="text-lg font-semibold">Content Media Analysis</h2>
        </motion.div>

        <div className="space-y-6">
          <div className="relative">
            <div className="bg-muted aspect-video rounded-lg relative">
              <div className="relative w-full pb-[100%] flex flex-col">
                <div className="absolute inset-0">
                  <img
                    src={
                      latestPost.thumbnail_url ||
                      latestPost.media_url ||
                      'https://placehold.co/400'
                    }
                    alt="Latest post thumbnail"
                    className="w-full h-full object-cover rounded-lg ratio"
                  />
                </div>
              </div>

              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="absolute top-4 right-4 cursor-help">
                      <div className="w-4 h-4 bg-primary rounded-full animate-pulse" />
                      <div className="absolute top-0 left-0 w-4 h-4 bg-primary rounded-full animate-ping opacity-75" />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p className="max-w-xs">
                      Try using brighter colors and more dynamic composition to
                      increase engagement.
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>

              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="absolute top-8 left-8 cursor-help">
                      <div className="w-4 h-4 bg-primary rounded-full animate-pulse" />
                      <div className="absolute top-0 left-0 w-4 h-4 bg-primary rounded-full animate-ping opacity-75" />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p className="max-w-xs">
                      You could use a more dynamic background to engage users
                      more
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>

              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-help">
                      <div className="w-4 h-4 bg-primary rounded-full animate-pulse" />
                      <div className="absolute top-0 left-0 w-4 h-4 bg-primary rounded-full animate-ping opacity-75" />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p className="max-w-xs">
                      Add a CTA for more urgency to drive better conversion
                      rates.
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
